export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фильтры"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Статус"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Магазин"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Счёт"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Применить"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Очистить всё"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выберите статус"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выберите магазин"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите номер инвойса"])}
}